import { Component } from "react";
import PromineoDataGrid from "../../../components/common/controls/grid/PromineoDataGrid";
import { Column, IDataGridOptions } from "devextreme-react/data-grid";
import { connect } from "react-redux";
import { RootState, AppDispatch } from "../../../store/store";
import { getFullDateFromString } from "../../../shared/utility/DateTimeUtility";
import ContactSales from "../../../interfaces/response/ContactSales";
import ContactSalesUpdateRequest from "interfaces/request/ContactSalesUpdateRequest";
import Loader from "../../../components/common/controls/Loader";
import StatusSelector from "./StatusSelector";
import ContactSalesGridActionHeader from "./ContactSalesGridActionHeader";
import { getContactSalesRequest, updateContactSalesRequest } from "../../../store/slices/ContactSalesSlice";

interface Props {
  dataSource?: ContactSales[];
  dispatch?: AppDispatch;
}

interface State {
  isLoading: boolean;
  slectedRowData?: ContactSales;
}

export class ContactSalesGrid extends Component<Props, State> {

  state: Readonly<State> = {
    isLoading: false,
    slectedRowData: undefined,
  };

  handleFilterChange = (selectedFilter?: number) => {
    this.setState({ isLoading: true });
    this.props.dispatch!(getContactSalesRequest(selectedFilter)).finally(() => {
      this.setState({ isLoading: false });
    });
  };

  handleStatusValueChange = (selectedRowId: number, data: any) => {
    const contactSalesUpdateRequest: ContactSalesUpdateRequest = {
      status: data
    };

    this.setState({ isLoading: true });
    this.props.dispatch!(updateContactSalesRequest({
      contactSalesId: selectedRowId,
      updateRequest: contactSalesUpdateRequest
    }))
    .finally(() => {
      this.setState({ isLoading: false });
    });
  }

  StatusCellRender = ({ data } : {data: ContactSales}) => {
    return <StatusSelector selectedRow={data} onValueChange={this.handleStatusValueChange} />;
  };
  
  render() {
    const dataGridOptions: IDataGridOptions = {
      dataSource: this.props.dataSource,
      keyExpr: "id"
    };

    return (
      <>
        <div className="mb-10">
          <ContactSalesGridActionHeader
            onFilterChange={this.handleFilterChange}
          />
        </div>
        <div className="mt-10 inline-flex">
          <PromineoDataGrid
            dataGridOptions={dataGridOptions}
            classNames="max-h-600px"
            noDataText="No Contact request found."
          >
            <Column
              dataField="name"
              caption="Name"
              width="20%"
            />
            <Column
              dataField="email"
              caption="Email"
              width="20%"
            />
            <Column
              dataField="phone"
              caption="Phone"
              width="20%"
            />
            <Column
              dataField="companyName"
              caption="Company Name"
              width="15%"
            />
            <Column
              dataField="product.name"
              caption="Product"
              width="15%"
            />
            <Column
              dataField="notes"
              caption="Notes"
              width="40%"
            />
            <Column
              dataField="created"
              caption="Created Date"
              width="15%"
              customizeText={(data: any) =>
                getFullDateFromString(data.generationTime)
              }
              alignment="center"
              sortOrder="desc"
            /> 
            <Column
              dataField="statusDisplayText"
              caption="Status"
              cellRender={this.StatusCellRender}
              width="20%"
            />
          </PromineoDataGrid>
        </div>
        <Loader isVisible={this.state.isLoading} />
      </>
    );
  }
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    dataSource: state.contactSalesData.contactSalesRequests,
    ...props,
  };
};

export default connect(mapStateToProps)(ContactSalesGrid);